import { render, staticRenderFns } from "./add-new-version.vue?vue&type=template&id=0821591a"
import script from "./add-new-version.vue?vue&type=script&lang=js"
export * from "./add-new-version.vue?vue&type=script&lang=js"
import style0 from "./add-new-version.vue?vue&type=style&index=0&id=0821591a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0821591a')) {
      api.createRecord('0821591a', component.options)
    } else {
      api.reload('0821591a', component.options)
    }
    module.hot.accept("./add-new-version.vue?vue&type=template&id=0821591a", function () {
      api.rerender('0821591a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/version-list/add-new-version.vue"
export default component.exports